<template>
  <footer class="general-footer">
    <div class="contenedor">
      <div class="grupoRedes">
        <a href="http://wa.me/3573413371" target="_blank">
          <ThemedIcon @click="asd" name="LuqueWpp" />
        </a>
        <a
          href="https://www.instagram.com/municipalidad_de_luque"
          target="_blank"
        >
          <ThemedIcon @click="asd" name="LuqueInstagram" />
        </a>
        <a href="https://www.facebook.com/MunicipalidaddeLuque" target="_blank">
          <ThemedIcon @click="asd" name="LuqueFacebook" />
        </a>
      </div>
      <p class="p-footer" id="direccion">
        Municipalidad de Luque | 9 de Julio 806, Luque, Córdoba | CP X5967 |
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="15"
          viewBox="0 0 12 15"
          fill="none"
        >
          <path
            d="M11.3598 13.3574C10.6522 14.0566 9.43935 14.2431 8.34676 14.0441C7.30646 13.852 6.57988 13.3077 5.75585 12.7292C5.01852 12.2159 4.34135 11.6081 3.74297 10.9701C2.54622 9.69428 1.63027 8.23967 1.01518 6.70583C0.823779 6.23401 0.672494 5.76473 0.536969 5.28943C0.359135 4.66056 0.228581 4.01362 0.270687 3.38111C0.279933 3.1185 0.329299 2.85843 0.415206 2.6112C0.71588 1.74588 1.39772 1.00293 2.40709 0.733394C2.99308 0.580956 3.73746 0.680675 4.17531 1.11193C4.65113 1.59121 4.70364 2.38411 4.80337 2.96242C4.87799 3.41632 4.9376 3.9921 4.70558 4.3845C4.47356 4.7769 3.94633 4.99622 3.51868 5.20429C3.22427 5.34359 3.13906 5.51015 3.22726 5.807C3.75931 7.65843 4.84868 9.24333 6.52687 10.5496C6.75044 10.7322 6.96824 10.7741 7.19962 10.6588C7.6466 10.4345 8.20813 9.88041 8.76837 9.88075C9.50486 9.88522 10.1247 10.4613 10.5884 10.9363C11.019 11.3882 11.785 12.0157 11.7293 12.6087C11.7093 12.9022 11.5396 13.1547 11.3441 13.3634L11.3598 13.3574Z"
            fill="var(--gris-claro)"
          />
        </svg>
        03573 48-0113
      </p>
    </div>
  </footer>
</template>

<script>
import ThemedIcon from "../Utils/ThemedIcon.vue";

export default {
  name: "FooterComponent",
  components: {
    ThemedIcon,
  },
};
</script>

<style scoped>
.general-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 11.686vh;
  width: calc(100% - 17%);
  padding: 3.339vh 3.66vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  z-index: 1;
  box-shadow: 0px -10px 30px 0px rgba(0, 0, 0, 0.05);
}

.contenedor {
  display: flex;
  flex-direction: row;
  gap: 8.565vw;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 100%;
  text-align: right;
}

.grupoRedes {
  display: flex;
  flex-direction: row;
  gap: 0.549vw;
  justify-content: space-between;
}
.grupoRedes img {
  width: var(--gapH30);
  height: var(--gap30);
}

.grupoRedes a {
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.grupoRedes a:hover {
  transform: translateY(-4px);
}

.grupoRedes a:active {
  transform: translateY(-1px);
}

.contenedor p {
  color: var(--gris-claro);
  margin: 0px;
}

#direccion {
  width: 56.785vw;
}
@media (max-width: 1360px) {
}
@media (max-width: 990px) {
  .general-footer {
    height: 17.863vh;
    width: 100%;
    position: unset;
    border-top: 1px solid var(--gris-claro);
  }
  #direccion {
    width: 100%;
  }
  .grupoRedes img {
    width: 33px;
    height: 33px;
  }
  .contenedor {
    gap: 5.565vw;
  }
}

@media (max-width: 770px) {
  .general-footer {
    height: 17.863vh;
    width: 100%;
    position: unset;
    border-top: 1px solid var(--gris-claro);
  }
  #direccion {
    width: 100%;
  }
  .contenedor {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 100%;
    height: 100%;
    padding-right: 0px;
    padding-left: 0px;
    text-align: center;
    gap: var(--gap15);
  }
  .grupoRedes {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
  }
  .grupoRedes img {
    width: 28px;
    height: 28px;
  }
  svg {
    display: none;
  }
}

@media (max-width: 460px) {
  .general-footer {
    height: 105px;
    padding: 2.504vh 0;
  }
  #direccion {
    width: 100%;
  }
}
</style>
